import './index.css';
import '@/styles/global.scss';
import '@/styles/desktop.scss';

import { Outlet, useLocation } from '@modern-js/runtime/router';
import { Provider } from '@modern-js/runtime/model';
import { Helmet } from '@modern-js/runtime/head';
import { GlobalProvider } from './globalProvider';
import { UserAuthProvider } from './auth';
import { DesktopThemeProvider } from '@/context/desktopThemeContext';
import { initializeDesktopTheme } from '@/utils/desktopTheme';
import { getRouteAppearance } from '@/utils/routeAppearance';

if (typeof window !== 'undefined' && getRouteAppearance(window.location.pathname).redesignEnabled) {
  initializeDesktopTheme();
}

export default function Layout() {
  const location = useLocation();
  const { redesignEnabled, bodyClassName } = getRouteAppearance(location.pathname);

  return (
    <>
      <Helmet bodyAttributes={{ class: bodyClassName }}>
        <title>HKMeeting</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1,viewport-fit=cover" />
        <meta httpEquiv="Pragma" content="no-cache" />
        <meta httpEquiv="Expires" content="0" />
        <meta name="renderer" content="webkit" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta httpEquiv="Cache-Control" content="no-siteapp" />
      </Helmet>

      <Provider>
        <DesktopThemeProvider enabled={redesignEnabled}>
          <GlobalProvider desktop={redesignEnabled}>
            <UserAuthProvider>
              <Outlet />
            </UserAuthProvider>
          </GlobalProvider>
        </DesktopThemeProvider>
      </Provider>
    </>
  );
}
